import React from 'react';
import { PERMISSIONS } from 'constants/permissions';
import { PaymentsTermsIcon } from 'components/common/icons';
import { Col, EditableInfoComponent, Row, Typography } from 'components';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';
import { usePricingRules } from './usePricingRules';
import { PricingRulesEditModal } from './edit';

const { Text } = Typography;

export const PricingRules = React.memo(() => {
  const { hasAccess } = useAccessControl();
  const { modalState, onModalStateChange, clientDetails } = usePricingRules();
  return (
    <>
      <EditableInfoComponent
        title={'Pricing Rules'}
        editable={hasAccess(PERMISSIONS.clients.pricing_rules.write)}
        icon={<PaymentsTermsIcon />}
        onEdite={onModalStateChange}
      />
      <Row gutter={[0, 4]}>
        <Col span={24}>
          <Row justify={'space-between'} align={'middle'}>
            <Col>
              <Text type={'secondary'}>Margin</Text>
            </Col>
            <Col>
              <Text type={'secondary'}>{clientDetails.margin !== null ? `${clientDetails.margin}%` : 'Not Set'}</Text>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row justify={'space-between'} align={'middle'}>
            <Col>
              <Text type={'secondary'}>Margin Range</Text>
            </Col>
            <Col>
              <Text type={'secondary'}>
                {clientDetails.minMargin !== null &&
                clientDetails.minMargin !== undefined &&
                clientDetails.maxMargin !== null &&
                clientDetails.maxMargin !== undefined
                  ? `${clientDetails.minMargin}-${clientDetails.maxMargin}%`
                  : clientDetails.minMargin !== null && clientDetails.minMargin !== undefined
                    ? `${clientDetails.minMargin} Min`
                    : clientDetails.maxMargin !== null && clientDetails.maxMargin !== undefined
                      ? `${clientDetails.maxMargin} Max`
                      : 'Not Set'}
              </Text>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row justify={'space-between'}>
            <Col>
              <Text type={'secondary'}>Discount</Text>
            </Col>
            <Col>
              <Text type={'secondary'}>
                {clientDetails.discount !== null ? `${clientDetails.discount}%` : 'Not Set'}
              </Text>
            </Col>
          </Row>
        </Col>
      </Row>
      <PricingRulesEditModal
        modalState={modalState}
        onModalStateChange={onModalStateChange}
        dataToEdit={clientDetails}
      />
    </>
  );
});
